









import Component from 'vue-class-component'
import { Vue, Watch } from 'vue-property-decorator'
import LimitForm from '@/components/limit/LimitForm.vue'
import limitStore from '@/stores/LimitsStore'
import Limit from '@/dto/limits/Limit'

@Component({
  components: { LimitForm },
})
export default class LimitEdit extends Vue {
  limitStore = limitStore
  limit: Limit | null = null

  @Watch('limitStore.limit', { immediate: true })
  setModel(limit: Limit) {
    this.limit = Object.assign({}, limit)
  }
}
